import { signOut, getMyGroup, updateUserName, changePassword, getNotificationPreferences, updateNotificationPreferences, } from "../auth/AuthGate";
import { applyPanel } from "./UiPanel";
import { playUiClick } from "../audio/sfx";
import { PARCHMENT, DANGER } from "./theme";
import { isAccessibilityMode, setAccessibilityMode } from "./accessibility";
import { createSwitchRow } from "./Switch";
import { ensurePushSubscription } from "../push";
import { createModal } from "./Modal";
const SECONDARY_BTN = `
  padding: 6px 14px;
  font-size: 12px;
  font-weight: 600;
  border-radius: 4px;
  border: 1px solid ${PARCHMENT.divider};
  background: transparent;
  color: ${PARCHMENT.text};
`;
const PRIMARY_BTN = `
  padding: 6px 14px;
  font-size: 12px;
  font-weight: 600;
  border-radius: 4px;
  border: 1px solid ${PARCHMENT.highlightBorder};
  background: ${PARCHMENT.highlightBg};
  color: ${PARCHMENT.text};
`;
const DANGER_BTN = `
  padding: 6px 14px;
  font-size: 12px;
  font-weight: 600;
  border-radius: 4px;
  border: 1px solid rgba(168, 58, 58, 0.5);
  background: rgba(168, 58, 58, 0.12);
  color: ${DANGER};
`;
const ICON_BTN = `
  padding: 2px 4px;
  font-size: 12px;
  border-radius: 4px;
  border: none;
  background: transparent;
  color: ${PARCHMENT.accent};
`;
const TEXT_INPUT = `
  width: 100%;
  box-sizing: border-box;
  padding: 6px 8px;
  font-size: 12px;
  border-radius: 4px;
  border: 1px solid ${PARCHMENT.divider};
  background: rgba(255, 255, 255, 0.55);
  color: ${PARCHMENT.text};
  margin-bottom: 6px;
`;
const ERROR_LINE = `font-size: 11px; color: ${DANGER}; margin: -2px 0 6px; display: none;`;
const SUCCESS_LINE = `font-size: 11px; color: #3d7a4a; margin: -2px 0 6px; display: none;`;
const DIVIDER = `border: none; border-top: 1px solid ${PARCHMENT.divider}; margin: 12px 0;`;
let showMyBuildingsHandler = null;
export function setShowMyBuildingsHandler(cb) {
    showMyBuildingsHandler = cb;
}
function styledButton(text, style) {
    const btn = document.createElement("button");
    btn.type = "button";
    btn.textContent = text;
    btn.style.cssText = style;
    return btn;
}
function renderLabeledText(el, label, value) {
    const strong = document.createElement("span");
    strong.style.fontWeight = "600";
    strong.textContent = `${label}:`;
    el.replaceChildren(strong, document.createTextNode(` ${value}`));
}
function styledInput(type, placeholder) {
    const input = document.createElement("input");
    input.type = type;
    input.placeholder = placeholder;
    input.autocomplete = type === "password" ? "new-password" : "off";
    input.style.cssText = TEXT_INPUT;
    return input;
}
export async function mountUserInfoModal(user) {
    const [myGroup, notifPrefs] = await Promise.all([
        getMyGroup(),
        getNotificationPreferences(),
    ]);
    const isAdmin = user.isSysadmin || myGroup?.role === "admin" || myGroup?.role === "owner";
    const btn = document.createElement("button");
    btn.title = "Mein Konto";
    btn.className =
        "fixed bottom-6 left-6 z-50 w-10 h-10 rounded-full bg-slate-800 text-slate-400 hover:bg-slate-700 flex items-center justify-center text-lg shadow-lg border-0";
    btn.textContent = "👤";
    document.body.appendChild(btn);
    const overlay = document.createElement("div");
    overlay.className =
        "hidden fixed inset-0 bg-black/60 z-50 items-center justify-center";
    document.body.appendChild(overlay);
    const card = document.createElement("div");
    card.className = "relative z-0 p-6 w-[300px] font-sans";
    card.style.color = PARCHMENT.text;
    overlay.appendChild(card);
    applyPanel(card, "beigeLight");
    // --- Main view ---
    const mainView = document.createElement("div");
    card.appendChild(mainView);
    // --- Header: user's name + button to open account details ---
    const header = document.createElement("div");
    header.style.cssText =
        "display: flex; align-items: center; justify-content: space-between; margin-bottom: 14px;";
    const nameHeading = document.createElement("h3");
    nameHeading.style.cssText = `font-size: 15px; font-weight: 700; margin: 0; color: ${PARCHMENT.text};`;
    const renderHeaderName = () => {
        nameHeading.textContent = user.name;
    };
    renderHeaderName();
    const accountBtn = styledButton("✏️ Bearbeiten", ICON_BTN);
    accountBtn.title = "Konto bearbeiten";
    accountBtn.addEventListener("click", () => {
        playUiClick();
        showAccountView();
    });
    header.append(nameHeading, accountBtn);
    mainView.appendChild(header);
    const headerDivider = document.createElement("hr");
    headerDivider.style.cssText = DIVIDER;
    mainView.appendChild(headerDivider);
    const myBuildingsBtn = styledButton("🏘️ Meine Gebäude", SECONDARY_BTN);
    myBuildingsBtn.style.width = "100%";
    myBuildingsBtn.style.marginBottom = "10px";
    myBuildingsBtn.addEventListener("click", () => {
        playUiClick();
        hide();
        showMyBuildingsHandler?.();
    });
    mainView.appendChild(myBuildingsBtn);
    const settingsBtn = styledButton("⚙️ Einstellungen", SECONDARY_BTN);
    settingsBtn.style.width = "100%";
    settingsBtn.style.marginBottom = "10px";
    settingsBtn.addEventListener("click", () => {
        playUiClick();
        showSettingsView();
    });
    mainView.appendChild(settingsBtn);
    if (isAdmin) {
        const dashboardBtn = styledButton("⚙️ Dashboard", PRIMARY_BTN);
        dashboardBtn.style.width = "100%";
        dashboardBtn.style.marginBottom = "10px";
        dashboardBtn.addEventListener("click", () => {
            playUiClick();
            window.location.href = user.isSysadmin ? "/sysadmin" : "/admin";
        });
        mainView.appendChild(dashboardBtn);
    }
    // --- Account details view ---
    const accountView = document.createElement("div");
    accountView.style.display = "none";
    card.appendChild(accountView);
    const accountBackBtn = styledButton("← Zurück", SECONDARY_BTN);
    accountBackBtn.style.width = "100%";
    accountBackBtn.style.marginBottom = "12px";
    accountBackBtn.addEventListener("click", () => {
        playUiClick();
        showMainView();
    });
    accountView.appendChild(accountBackBtn);
    // --- Name row (view mode) ---
    const nameRow = document.createElement("div");
    nameRow.style.cssText =
        "display: flex; align-items: center; justify-content: space-between; margin-bottom: 8px;";
    const nameLabel = document.createElement("span");
    nameLabel.style.cssText = "font-size: 13px;";
    const renderName = () => {
        renderLabeledText(nameLabel, "Name", user.name);
    };
    renderName();
    const editNameBtn = styledButton("✏️", ICON_BTN);
    editNameBtn.title = "Name ändern";
    nameRow.append(nameLabel, editNameBtn);
    accountView.appendChild(nameRow);
    // --- Name row (edit mode) ---
    const nameForm = document.createElement("div");
    nameForm.style.cssText = "display: none; margin-bottom: 8px;";
    const nameInput = styledInput("text", "Dein Name");
    const nameError = document.createElement("div");
    nameError.style.cssText = ERROR_LINE;
    const nameActions = document.createElement("div");
    nameActions.style.cssText = "display: flex; gap: 8px;";
    const nameSaveBtn = styledButton("Speichern", PRIMARY_BTN);
    const nameCancelBtn = styledButton("Abbrechen", SECONDARY_BTN);
    nameActions.append(nameSaveBtn, nameCancelBtn);
    nameForm.append(nameInput, nameError, nameActions);
    accountView.appendChild(nameForm);
    const showNameForm = () => {
        nameInput.value = user.name;
        nameError.style.display = "none";
        nameRow.style.display = "none";
        nameForm.style.display = "block";
        nameInput.focus();
    };
    const hideNameForm = () => {
        nameRow.style.display = "flex";
        nameForm.style.display = "none";
    };
    editNameBtn.addEventListener("click", () => {
        playUiClick();
        showNameForm();
    });
    nameCancelBtn.addEventListener("click", () => {
        playUiClick();
        hideNameForm();
    });
    nameSaveBtn.addEventListener("click", () => {
        const newName = nameInput.value.trim();
        if (!newName) {
            nameError.textContent = "Name darf nicht leer sein.";
            nameError.style.display = "block";
            return;
        }
        playUiClick();
        nameSaveBtn.disabled = true;
        nameCancelBtn.disabled = true;
        nameError.style.display = "none";
        void updateUserName(newName)
            .then(() => {
            user.name = newName;
            renderName();
            renderHeaderName();
            hideNameForm();
        })
            .catch((err) => {
            nameError.textContent =
                err instanceof Error
                    ? err.message
                    : "Name konnte nicht geändert werden.";
            nameError.style.display = "block";
        })
            .finally(() => {
            nameSaveBtn.disabled = false;
            nameCancelBtn.disabled = false;
        });
    });
    // --- E-Mail (static) ---
    const emailLine = document.createElement("p");
    emailLine.style.cssText = "font-size: 13px; margin-bottom: 4px;";
    renderLabeledText(emailLine, "E-Mail", user.email);
    accountView.appendChild(emailLine);
    if (user.playerCode) {
        const codeRow = document.createElement("div");
        codeRow.style.cssText =
            "display: flex; align-items: center; justify-content: space-between; margin-bottom: 4px;";
        const codeLabel = document.createElement("span");
        codeLabel.style.cssText = "font-size: 13px;";
        const strong = document.createElement("span");
        strong.style.fontWeight = "600";
        strong.textContent = "Code:";
        const codeVal = document.createElement("code");
        codeVal.style.fontFamily = "monospace";
        codeVal.style.marginLeft = "4px";
        codeVal.textContent = user.playerCode;
        codeLabel.append(strong, codeVal);
        const copyCodeBtn = styledButton("📋", ICON_BTN);
        copyCodeBtn.title = "Code kopieren";
        copyCodeBtn.addEventListener("click", () => {
            playUiClick();
            void navigator.clipboard.writeText(user.playerCode).then(() => {
                copyCodeBtn.textContent = "✓";
                setTimeout(() => {
                    copyCodeBtn.textContent = "📋";
                }, 2000);
            });
        });
        codeRow.append(codeLabel, copyCodeBtn);
        accountView.appendChild(codeRow);
    }
    const divider1 = document.createElement("hr");
    divider1.style.cssText = DIVIDER;
    accountView.appendChild(divider1);
    // --- Password change (collapsible) ---
    const passwordToggleBtn = styledButton("🔒 Passwort ändern", SECONDARY_BTN);
    passwordToggleBtn.style.width = "100%";
    accountView.appendChild(passwordToggleBtn);
    const passwordForm = document.createElement("form");
    passwordForm.style.cssText = "display: none; margin-top: 10px;";
    const currentPasswordInput = styledInput("password", "Aktuelles Passwort");
    currentPasswordInput.autocomplete = "current-password";
    const newPasswordInput = styledInput("password", "Neues Passwort");
    const confirmPasswordInput = styledInput("password", "Neues Passwort bestätigen");
    const passwordError = document.createElement("div");
    passwordError.style.cssText = ERROR_LINE;
    const passwordSuccess = document.createElement("div");
    passwordSuccess.style.cssText = SUCCESS_LINE;
    passwordSuccess.textContent = "Passwort geändert ✓";
    const passwordActions = document.createElement("div");
    passwordActions.style.cssText = "display: flex; gap: 8px;";
    const passwordSaveBtn = styledButton("Speichern", PRIMARY_BTN);
    passwordSaveBtn.type = "submit";
    const passwordCancelBtn = styledButton("Abbrechen", SECONDARY_BTN);
    passwordActions.append(passwordSaveBtn, passwordCancelBtn);
    passwordForm.append(currentPasswordInput, newPasswordInput, confirmPasswordInput, passwordError, passwordSuccess, passwordActions);
    accountView.appendChild(passwordForm);
    const resetPasswordForm = () => {
        currentPasswordInput.value = "";
        newPasswordInput.value = "";
        confirmPasswordInput.value = "";
        passwordError.style.display = "none";
        passwordSuccess.style.display = "none";
    };
    const showPasswordForm = () => {
        resetPasswordForm();
        passwordToggleBtn.style.display = "none";
        passwordForm.style.display = "block";
        currentPasswordInput.focus();
    };
    const hidePasswordForm = () => {
        passwordToggleBtn.style.display = "block";
        passwordForm.style.display = "none";
    };
    passwordToggleBtn.addEventListener("click", () => {
        playUiClick();
        showPasswordForm();
    });
    passwordCancelBtn.addEventListener("click", () => {
        playUiClick();
        hidePasswordForm();
    });
    passwordForm.addEventListener("submit", (e) => {
        e.preventDefault();
        passwordError.style.display = "none";
        passwordSuccess.style.display = "none";
        const current = currentPasswordInput.value;
        const next = newPasswordInput.value;
        const confirm = confirmPasswordInput.value;
        if (!current || !next) {
            passwordError.textContent = "Bitte alle Felder ausfüllen.";
            passwordError.style.display = "block";
            return;
        }
        if (next.length < 8) {
            passwordError.textContent =
                "Das neue Passwort muss mindestens 8 Zeichen haben.";
            passwordError.style.display = "block";
            return;
        }
        if (next !== confirm) {
            passwordError.textContent = "Die Passwörter stimmen nicht überein.";
            passwordError.style.display = "block";
            return;
        }
        playUiClick();
        passwordSaveBtn.disabled = true;
        passwordCancelBtn.disabled = true;
        void changePassword(current, next)
            .then(() => {
            passwordSuccess.style.display = "block";
            currentPasswordInput.value = "";
            newPasswordInput.value = "";
            confirmPasswordInput.value = "";
            setTimeout(hidePasswordForm, 1600);
        })
            .catch((err) => {
            passwordError.textContent =
                err instanceof Error
                    ? err.message
                    : "Passwort konnte nicht geändert werden.";
            passwordError.style.display = "block";
        })
            .finally(() => {
            passwordSaveBtn.disabled = false;
            passwordCancelBtn.disabled = false;
        });
    });
    // --- Settings view ---
    const settingsView = document.createElement("div");
    settingsView.style.display = "none";
    card.appendChild(settingsView);
    const settingsBackBtn = styledButton("← Zurück", SECONDARY_BTN);
    settingsBackBtn.style.width = "100%";
    settingsBackBtn.style.marginBottom = "12px";
    settingsBackBtn.addEventListener("click", () => {
        playUiClick();
        showMainView();
    });
    settingsView.appendChild(settingsBackBtn);
    const accessibilitySwitch = createSwitchRow("Bedienungshilfen", isAccessibilityMode(), (checked) => setAccessibilityMode(checked));
    accessibilitySwitch.row.title =
        "Klicken statt Hovern, Bildschirm-Buttons zum Zoomen & Verschieben";
    accessibilitySwitch.row.style.marginBottom = "10px";
    settingsView.appendChild(accessibilitySwitch.row);
    const settingsDivider = document.createElement("hr");
    settingsDivider.style.cssText = DIVIDER;
    settingsView.appendChild(settingsDivider);
    const notificationsHeading = document.createElement("div");
    notificationsHeading.textContent = "Benachrichtigungen";
    notificationsHeading.style.cssText =
        "font-size: 12px; font-weight: 700; margin-bottom: 8px;";
    settingsView.appendChild(notificationsHeading);
    const notifError = document.createElement("div");
    notifError.style.cssText = ERROR_LINE;
    settingsView.appendChild(notifError);
    const permissionErrorMessage = (permission) => permission === "unsupported"
        ? "Push-Benachrichtigungen werden von diesem Browser nicht unterstützt."
        : "Bitte erlaube Benachrichtigungen in den Browser-Einstellungen.";
    const handleNotifToggle = (checked, field, switchHandle) => {
        notifError.style.display = "none";
        void (async () => {
            if (checked) {
                const permission = await ensurePushSubscription();
                if (permission !== "granted") {
                    switchHandle.setChecked(false);
                    notifError.textContent = permissionErrorMessage(permission);
                    notifError.style.display = "block";
                    return;
                }
            }
            try {
                await updateNotificationPreferences({ [field]: checked });
            }
            catch (err) {
                switchHandle.setChecked(!checked);
                notifError.textContent =
                    err instanceof Error
                        ? err.message
                        : "Einstellung konnte nicht gespeichert werden.";
                notifError.style.display = "block";
            }
        })();
    };
    const ownBuildingsSwitch = createSwitchRow("Eigene Gebäude", notifPrefs.notifyOwnBuildings, (checked) => {
        handleNotifToggle(checked, "notifyOwnBuildings", ownBuildingsSwitch);
    });
    ownBuildingsSwitch.row.title =
        "Benachrichtigung, wenn ein neues Gebäude für dich erstellt wird";
    ownBuildingsSwitch.row.style.marginBottom = "10px";
    settingsView.appendChild(ownBuildingsSwitch.row);
    const othersBuildingsSwitch = createSwitchRow("Gebäude anderer", notifPrefs.notifyOthersBuildings, (checked) => {
        handleNotifToggle(checked, "notifyOthersBuildings", othersBuildingsSwitch);
    });
    othersBuildingsSwitch.row.title =
        "Benachrichtigung, wenn ein neues Gebäude für andere Mitglieder eurer Gruppe erstellt wird";
    settingsView.appendChild(othersBuildingsSwitch.row);
    const bottomActions = document.createElement("div");
    bottomActions.style.cssText = "display: flex; gap: 8px; margin-top: 12px;";
    const logoutBtn = styledButton("Abmelden", DANGER_BTN);
    const closeBtn = styledButton("Schließen", SECONDARY_BTN);
    closeBtn.style.flex = "1";
    // --- View switching (mainView / accountView / settingsView are mutually exclusive).
    // Sign out / close only make sense at the top level, not while inside a submenu.
    const views = [mainView, accountView, settingsView];
    const showView = (target) => {
        for (const view of views)
            view.style.display = view === target ? "block" : "none";
        bottomActions.style.display = target === mainView ? "flex" : "none";
    };
    const showMainView = () => showView(mainView);
    const showAccountView = () => showView(accountView);
    const showSettingsView = () => showView(settingsView);
    bottomActions.append(logoutBtn, closeBtn);
    card.appendChild(bottomActions);
    const modal = createModal({ panel: card, labelledBy: nameHeading });
    const show = () => {
        overlay.classList.remove("hidden");
        overlay.classList.add("flex");
        modal.open(hide);
    };
    const hide = () => {
        overlay.classList.add("hidden");
        overlay.classList.remove("flex");
        hideNameForm();
        hidePasswordForm();
        showMainView();
        modal.close();
    };
    btn.addEventListener("click", () => {
        playUiClick();
        show();
    });
    closeBtn.addEventListener("click", () => {
        playUiClick();
        hide();
    });
    overlay.addEventListener("click", (e) => {
        if (e.target === overlay)
            hide();
    });
    logoutBtn.addEventListener("click", () => {
        playUiClick();
        void signOut()
            .catch(() => { })
            .finally(() => {
            window.location.href = "/";
        });
    });
}
